module.exports = __webpack_public_path__ + "img/menu-mobile-close.957a3c0f.svg";